export const ACCESS_TOKEN = process.env.REACT_APP_APP_ENV === "prod" ? "at" : "preprod-at";
export const REFRESH_TOKEN = process.env.REACT_APP_APP_ENV === "prod" ? "rt" : "preprod-rt";
export const ACCESS_TOKEN_FROM_URL = "at";
export const REFRESH_TOKEN_FROM_URL = "rt";
export const DAID = "daid";
export const REDIRECTED = "redirected";
export const RETURN_URL = "returnUrl";
